<script setup lang="ts" name="ErrorInvitationExpired">
import BaseCardState from '~/components/BaseCardState.vue';

import ErrorLayout from '~/pages/ErrorLayout.vue';
</script>

<template>
  <ErrorLayout>
    <BaseCardState
      title="Your Invitation Expired"
      illustration="invitation-expired"
    >
      <template #message>
        <p class="mt-2 text-body-1 text-charcoal-9">
          Contact your admin or
          <a
            href="mailto:myg2support@g2ocean.com"
            class="text-primary-8"
            target="_blank"
            >support team</a
          >
          to request another invite.
        </p>
      </template>
    </BaseCardState>
  </ErrorLayout>
</template>
